import React from 'react';

import { link } from '@aline/routes';
import { IconButton, Skeleton, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';
import { EditableNameVariant, Spacer, WorkflowStage } from 'src/components';
import { BackArrowIcon } from 'src/components/icons/BackArrowIcon';
import { Apollo } from 'src/gql/generated';
import { useGetWorkflowInboxWorkflow } from 'src/hooks';
import { DeleteWorkflowIconButton, PrimaryWorkflowButton, WorkflowNameInput } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  toolbar: {
    gap: theme.spacing(2),
    padding: theme.spacing(0, 2),
  },
}));

interface WorkflowBuilderToolbarProps {
  workflowId: UUID;
  backRoute?: string;
}

export function WorkflowBuilderToolbar({
  backRoute,
  workflowId,
}: WorkflowBuilderToolbarProps): JSX.Element {
  const { classes } = useStyles();
  const { loading, workflow } = useGetWorkflowInboxWorkflow(workflowId);
  const isTemplate = workflow?.variant === Apollo.WorkflowVariant.Template;
  const isPublished = Boolean(workflow?.publishedAt);

  const backTo = backRoute
    ? backRoute
    : isTemplate
      ? isPublished
        ? link.TemplatePublished()
        : link.TemplateDraft()
      : link.WorkflowList();

  if (loading || !workflow)
    return (
      <Toolbar className={classes.toolbar}>
        <IconButton component={Link} size="small" to={backTo}>
          <BackArrowIcon />
        </IconButton>
        <Skeleton height={32} variant="rectangular" width={100} />
      </Toolbar>
    );

  return (
    <Toolbar className={classes.toolbar}>
      <IconButton component={Link} size="small" to={backTo}>
        <BackArrowIcon />
      </IconButton>
      <WorkflowNameInput variant={EditableNameVariant.LargeText} workflowId={workflowId} />
      <Spacer />
      <WorkflowStage workflow={workflow} />
      <DeleteWorkflowIconButton workflowId={workflow.id} />
      <PrimaryWorkflowButton workflow={workflow} />
    </Toolbar>
  );
}
